import {TYPES} from '../Actions/errorCodeAction';

const errorCodeReducer = (state = {}, action) => {
    switch (action.type) {
        case TYPES.FETCH_ERROR_CODE_SUCCESS:
            return {
                ...state,
                errorCode: action.errorCode
            };
        default:
            return state;
    }
};

export default errorCodeReducer;



// WEBPACK FOOTER //
// ./src/ReduxRequests/Reducer/errorCodeReducer.ts